import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const PURCHASED_ORDER_URL = `${backendUrl}/purchasedOrder`;

const initialState = {
  isLoading: false,
  error: null,
  purchasedOrders: [],
  purchasedOrder: null,
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "accountsPurchasedOrder",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getPurchasedOrdersSuccess(state, action) {
      const payload = action.payload || {};
      state.isLoading = false;
      state.purchasedOrders = payload.results || [];
      state.page = payload.page || 1;
      state.limit = payload.limit || 10;
      state.totalPages = payload.totalPages || 0;
      state.totalResults = payload.totalResults || 0;
    },
    getPurchasedOrderSuccess(state, action) {
      state.isLoading = false;
      state.purchasedOrder = action.payload;
    },
    clearPurchasedOrder(state) {
      state.purchasedOrder = null;
      state.error = null;
    },
  },
});

export default slice.reducer;

export function getAccountsPurchasedOrders({ franchiseId, warehouseId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(PURCHASED_ORDER_URL, {
        params: { franchiseId, warehouseId, page, limit },
      });
      dispatch(slice.actions.getPurchasedOrdersSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function getAccountsPurchasedOrder(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${PURCHASED_ORDER_URL}/${id}`);
      dispatch(slice.actions.getPurchasedOrderSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function createAccountsPurchasedOrder(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(PURCHASED_ORDER_URL, data);
      dispatch(slice.actions.getPurchasedOrderSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateAccountsPurchasedOrder(id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`${PURCHASED_ORDER_URL}/${id}`, data);
      dispatch(slice.actions.getPurchasedOrderSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export const { clearPurchasedOrder } = slice.actions;
